








import { Component, Mixins } from "vue-property-decorator";
import { InjectedObjectEvidenceUrlPresentableMixin } from "./mixins";    

@Component
export default class InjectedObjectEvidenceUrlContentDrawer extends Mixins(InjectedObjectEvidenceUrlPresentableMixin) {
  openPage() {
    window.open(this.url, "_blank", "noopener,noreferrer");
  }
}
